import React, { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ReleaseFooter = () => {
  const [release, setRelease] = useState(null);

  useEffect(() => {
    loadCurrentRelease();
  }, []);

  const loadCurrentRelease = async () => {
    try {
      const response = await axios.get(`${API}/meta/current-release?environment=production`);
      setRelease(response.data);
    } catch (error) {
      console.error("Error loading release info:", error);
    }
  };

  if (!release) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="text-center py-2 px-4 text-xs text-slate-500 mb-4">
      <span className="font-semibold">{release.stage}</span> — <span>v{release.version}</span> — <span>Build {release.build_id}</span>
      {release.deployed_at && <span> — Deployed {formatDate(release.deployed_at)}</span>}
    </div>
  );
};

export default ReleaseFooter;
